// extracted by mini-css-extract-plugin
module.exports = {"name":"ReminderToJoinPopup_name__163JB"};